(function (w) {
  if (w.$track) return;
  const baseUrl = $("input[data-base-url]").val();
  const ENDPOINT = `${baseUrl}/api/fbapp/track.gif`

  const BATCH_SIZE = 10;
  const BATCH_DELAY = 1000;
  /* -------------------- 工具 -------------------- */

  function getCookie(name) {
    const match = document.cookie.match(
      new RegExp('(?:^|; )' + name + '=([^;]*)')
    );
    return match ? decodeURIComponent(match[1]) : '';
  }

  function getUTM() {
    const params = new URLSearchParams(location.search);
    return {
      utmCampaign: params.get('utm_campaign') || '',
      utmSource: params.get('utm_source') || '',
      utmMedium: params.get('utm_medium') || '',
      utmTerm: params.get('utm_term') || '',
      utmContent: params.get('utm_content') || ''
    };
  }

  function getReferrerHost() {
    if (!document.referrer) return '';
    try {
      return new URL(document.referrer).host;
    } catch {
      return '';
    }
  }

  function getDeviceType() {
    return /Mobile|Android|iPhone|iPad|iPod/i.test(navigator.userAgent)
      ? 'h5'
      : 'pc';
  }
  w.getDeviceType = getDeviceType;
  function formatClientTime(date = new Date()) {
    const parts = new Intl.DateTimeFormat('sv-SE', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    }).formatToParts(date)

    const map = {}
    parts.forEach(p => {
      if (p.type !== 'literal') {
        map[p.type] = p.value
      }
    })

    return `${map.year}-${map.month}-${map.day} ${map.hour}:${map.minute}:${map.second}`
  }


  /* -------------------- 公共字段 -------------------- */

  function baseContext() {
    return {
      urlPath: location.href,
      referrer: document.referrer || '',
      referrerHost: getReferrerHost(),
      clientTime: formatClientTime(),
      sessionId: getCookie('_shopify_s') || '',
      userId: getCookie('_shopify_y') || '',
      country: window.Shopify?.country || '',
      deviceType: getDeviceType(),
      ...getUTM()
    };
  }

  /* -------------------- 上报 -------------------- */
  function send(payload) {
    const body = btoa(
      unescape(encodeURIComponent(JSON.stringify(payload)))
    );

    if (navigator.sendBeacon) {
      navigator.sendBeacon(ENDPOINT, body);
    } else {
      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'image/gif' },
        keepalive: true,
        body
      });
    }
  }

  function track(event, data = {}) {
    send({
      event,
      ...baseContext(),
      ...data
    });
  }

  const exposeBatchBuffer = [];
  let exposeBatchTimer = null;

  function flushExposeBatch() {
    if (!exposeBatchBuffer.length) return;
    const moduleMap = {};

    exposeBatchBuffer.forEach(item => {
      const { moduleId = '', trackItems = [], ...rest } = item;
      if (!moduleMap[moduleId]) {
        moduleMap[moduleId] = {
          moduleId,
          ...rest,
          trackItems: []
        };
      }
      moduleMap[moduleId].trackItems.push(...trackItems);
    });
    Object.values(moduleMap).forEach(payload => {
      track('Expose', payload);
    });
    exposeBatchBuffer.length = 0;
    clearTimeout(exposeBatchTimer);
    exposeBatchTimer = null;
  }
  /* -------------------- 曝光 -------------------- */

  const exposedSet = new Set();

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;

        const el = entry.target;
        const key = el.dataset.trackKey || el;

        if (exposedSet.has(key)) return;
        exposedSet.add(key);

        const builder = el.__exposeBuilder;
        if (!builder) return;
        const data = builder(el);
        if (el.dataset.abVariant) {
          track('Expose', {
            ...data,
          });
        }
        else if (data && data._batch) {
          exposeBatchBuffer.push(data);
          if (exposeBatchBuffer.length >= BATCH_SIZE) {
            flushExposeBatch();
          } else if (!exposeBatchTimer) {
            exposeBatchTimer = setTimeout(flushExposeBatch, BATCH_DELAY);
          }
        }
        else {
          track('expose', data);
        }

        observer.unobserve(el);
      });
    },
    { threshold: 0.5 }
  );

  function bindExpose(el, builder) {
    if (el.__exposeBound) return;
    el.__exposeBound = true;
    el.__exposeBuilder = builder;
    observer.observe(el);
  }

  function expose(selector, builder) {
    document.querySelectorAll(selector).forEach(el => bindExpose(el, builder));
    const container = document.querySelector('body');
    if (container && !container.__mutationBound) {
      container.__mutationBound = true;
      const mo = new MutationObserver(() => {
        document.querySelectorAll(selector).forEach(el => bindExpose(el, builder));
      });
      mo.observe(container, { childList: true, subtree: true });
    }
  }

  /* -------------------- 点击 -------------------- */

  function bindClick(selector, builder) {
    document.addEventListener('click', (e) => {
      const el = e.target.closest(selector);
      if (!el) return;
      track('click', builder(el));
    });
  }

  w.$track = {
    track,
    expose,
    bindClick
  };
})(window);


document.addEventListener('DOMContentLoaded', function () {
  // 商品的曝光
  $track.expose('.fabrique-product-wrapper', function (el) {
    const moduleId = el.closest('[data-track-module]')?.dataset.trackModule || '';
    const img = el.querySelector('img.fabrique-product-image-abtest');
    let abtestExperimentGroup = el.dataset.abVariant || '';
    let abtestExperimentId = img?.getAttribute('data_ai_img_feature_id') || '';
    if (moduleId === 'how_to_style_it') {
      const position = el.querySelector('a.fabrique-product-image-link')?.dataset.position || '';
      abtestExperimentGroup = position === 'GensmoStyleIt' ? 'a' : 'b';
      abtestExperimentId = 'ai_match';
    }
    return {
      _batch: true,
      trackItems: [
        {
          img: img?.getAttribute('src') || '',
          handle: el.dataset.handle || '',
          name: el.dataset.productName || '',
          styleNo: el.dataset.styleNo || '',
          abtestExperimentGroup: abtestExperimentGroup,
          abtestExperimentId: abtestExperimentId,
        },
      ],
      event: 'Expose',
      moduleId: moduleId,
    };
  });
  // 点击商品的详情
  $track.bindClick('.fabrique-product-wrapper', function (el) {
    const moduleId = el.closest('[data-track-module]')?.dataset.trackModule || '';
    const img = el.querySelector('img.fabrique-product-image-abtest');
    let abtestExperimentGroup = el.dataset.abVariant || '';
    let abtestExperimentId = img?.getAttribute('data_ai_img_feature_id') || '';
    if (moduleId === 'how_to_style_it') {
      const position = el.querySelector('a.fabrique-product-image-link')?.dataset.position || '';
      abtestExperimentGroup = position === 'GensmoStyleIt' ? 'a' : 'b';
      abtestExperimentId = 'ai_match';
    }
    return {
      event: 'ProductView',
      moduleId: moduleId,
      trackItems: [
        {
          img: img?.getAttribute('src') || '',
          handle: el.dataset.handle || '',
          name: el.dataset.productName || '',
          styleNo: el.dataset.styleNo || '',
          abtestExperimentGroup,
          abtestExperimentId,
        },
      ],
    };
  });

  // 添加商品到购物车
  function getTrackData(options = {}) {
    const {
      imgSelector = 'img.fabrique-product-image-abtest',
      useDatasetOnly = false,
    } = options;

    const img = document.querySelector(imgSelector);

    // dataset 方式（quick cart 用）
    if (useDatasetOnly) {
      return {
        img: img?.getAttribute('src') || '',
        handle: img?.dataset.handle || '',
        name: img?.dataset.productName || '',
        styleNo: img?.dataset.styleNo || '',
        abtestExperimentGroup: img?.dataset.abVariant || '',
        abtestExperimentId: img?.getAttribute('data_ai_img_feature_id') || '',
      };
    }

    // 默认方式（PDP 用）
    return {
      img: img?.getAttribute('src') || '',
      handle: $('input[data-good-handle]').val() || '',
      name: $('input[data-good-title]').val() || '',
      styleNo: $('input[data-style-no]').val() || '',
      abtestExperimentGroup: img?.dataset.abVariant || '',
      abtestExperimentId: img?.getAttribute('data_ai_img_feature_id') || '',
    };
  }

  // 通用绑定方法
  function bindAddToCart(selector, options) {
    $track.bindClick(selector, function () {
      return {
        event: 'AddToCart',
        trackItems: [getTrackData(options)],
      };
    });
  }

  // ===== 使用 =====

  // PDP 按钮
  bindAddToCart('.product-form .product-form__submit');

  // sticky cart
  bindAddToCart('.product__sticky-cart-wrapper .product-bar__submit');

  // quick cart（用 dataset）
  bindAddToCart('.product-card-quick-cart-sumbit', {
    imgSelector: '.quick-cart-product img.fabrique-product-image-abtest',
    useDatasetOnly: true,
  });



  function getCartTrackItems() {
    const trackItems = [];
    const cartProducts = document.querySelectorAll('#CartDrawer-CartItems .cart-item');
    cartProducts.forEach(cartProduct => {
      const layout = cartProduct.querySelector('.cart-item__media');
      console.log(cartProduct)
      console.log(layout)
      if (!layout) return;
      const img = layout.querySelector('.fabrique-product-image-abtest');
      if (!img) return;
      const variant = img.getAttribute('data-ab-variant') || '';
      const featureId = img.getAttribute('data_ai_img_feature_id') || '';
      const item = {
        quantity: parseInt(img.getAttribute('data-quantity') || 1, 10),
        handle: img.getAttribute('data-handle') || '',
        abtestExperimentGroup: variant,
        abtestExperimentId: variant && featureId ? featureId : '',
        name: img.getAttribute('data-product-name') || '',
        styleNo: img.getAttribute('data-style-no') || '',
        img: img.getAttribute('src') || '',
      };
      trackItems.push(item);
    });
    return trackItems;
  }
  // checkout 点击
  $track.bindClick('button[name="checkout"]', function (el) {
    const trackItems = getCartTrackItems();
    return {
      event: 'CheckOut',
      trackItems
    };
  });
  // 页面的浏览
  const handle = $('input[data-good-handle]').val();
  const styleNo = $('input[data-style-no]').val();
  const productName = $('input[data-good-title]').val();

  $track.track('PageView', {
    trackItems: [{
      handle: handle || '',
      name: productName || '',
      styleNo: styleNo || '',
    }],
  });

  $track.bindClick('.fbrq-menu-link-gtmClass', function (el) {
  return {
    event: 'WebClick',
    moduleType: 'nav_grid',
    trackItems: [
      {
        name: el.dataset.name || el.innerText.trim(),
        handle: el.dataset.href || el.getAttribute('href') || '',
      },
    ],
  };
});

});
// =========================
// ✅ Banner 埋点（新版适配 Shopify hero banner）
// =========================

(function () {
  const moduleId = 'home_banner';
  const moduleType = 'banner_carousel';

  const exposed = new Set();

  // 获取数据（不依赖 dataset）
  function getSlideData(el, index = 0) {
    const headingEl = el.querySelector('.hero__heading');
    const isMobile = getDeviceType() === 'h5';
    let imgEl;

    if (isMobile) {
      imgEl = el.querySelector('.small-up-hide img');
    } else {
      imgEl = el.querySelector('.small-hide img');
    }
    if (!imgEl) {
      imgEl = el.querySelector('img');
    }
    const videoEl = el.querySelector('video');

    return {
      id: el.dataset.index || index,
      index: index + 1,
      name: headingEl?.innerText?.trim() || '',
      img:
        imgEl?.currentSrc ||
        imgEl?.src ||
        videoEl?.poster ||
        '',
    };
  }

  function reportExpose(el, index) {
    const key = el.dataset.index || index;
    if (exposed.has(key)) return;

    exposed.add(key);

    const data = getSlideData(el, index);

    $track.track('BannerExpose', {
      trackItems: [
        {
          handle: data.id,
          modulePos: data.index,
          name: data.name,
          img: data.img,
        }
      ],
      event: 'ModuleExpose',
      moduleId,
      moduleType,
    });
  }
  // =========================
  // ✅ 单图
  // =========================
  const swiperEl = document.querySelector('.hero__swiper');

  if (!swiperEl) {
    const single = document.querySelector('.hero__inner');
    if (!single) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            reportExpose(single, 0);
            observer.disconnect();
          }
        });
      },
      { threshold: 0.5 }
    );

    observer.observe(single);

    // 点击
    single.addEventListener('click', (e) => {
      const link = e.target.closest('a');
      if (!link) return;

      const data = getSlideData(single, 0);

      $track.track('WebClick', {
        trackItems: [
          {
            name: data.name,
            modulePos: data.index,
            handle: link.href,
            img: data.img,
          }
        ],
        event: 'WebClick',
        moduleId,
        moduleType,
      });
    });

    return;
  }
  // =========================
  // ✅ 多图
  // =========================
  const swiper = swiperEl.swiper || swiperEl.querySelector('.swiper')?.swiper;
  if (!swiper) return;

  const slides = swiper.slides;

  // 可视曝光
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;

        const el = entry.target;
        const index = [...slides].indexOf(el);

        reportExpose(el, index);
      });
    },
    { threshold: 0.6 }
  );

  slides.forEach(slide => observer.observe(slide));
  const activeIndex = swiper.activeIndex;
  const activeSlide = slides[activeIndex];
  if (activeSlide) {
    requestAnimationFrame(() => {
      reportExpose(activeSlide, activeIndex);
    });
  }

  // 切换兜底
  swiper.on('slideChange', () => {
    const index = swiper.activeIndex;
    const slide = slides[index];
    if (slide) reportExpose(slide, index);
  });

  slides.forEach((slide, index) => {
    const video = slide.querySelector('video');
    if (!video) return;

    video.addEventListener('play', () => {
      reportExpose(slide, index);
    });
  });

  swiperEl.addEventListener('click', (e) => {
    const link = e.target.closest('a');
    if (!link) return;

    const slide = link.closest('.swiper-slide');
    if (!slide) return;

    const index = [...slides].indexOf(slide);
    const data = getSlideData(slide, index);

    $track.track('WebClick', {
      trackItems: [
        {
          name: data.name,
          modulePos: data.index,
          handle: link.href,
          img: data.img,
        }
      ],
      event: 'WebClick',
      moduleId,
      moduleType,
    });
  });

})();
